import {
  type RunsDataQueryConfig,
  toRunsDataQueryConfig,
} from '../../containers/RunsDataLoader';
import {createPreloadableLazyComponent} from '../../util/lazyImport';
import type {PanelSpec} from '../../util/panelTypes';
import {type Query} from '../../util/queryTypes';
import {type MarkdownConfig} from './common';
export type {MarkdownConfig};

const PANEL_TYPE = 'Markdown Panel';

const transformQuery = (query: Query): RunsDataQueryConfig => {
  const result = toRunsDataQueryConfig(query, undefined, {
    panelType: PANEL_TYPE,
  });
  result.disabled = true;
  return result;
};

export const Spec: PanelSpec<typeof PANEL_TYPE, MarkdownConfig> = {
  type: PANEL_TYPE,
  Component: createPreloadableLazyComponent(() => import('./Component'))
    .Component,
  transformQuery,
  noEditMode: true,
  icon: 'panel-text',
};
